import React from 'react';
import { Modal, Table } from 'antd';
import moment from 'moment';
import { contractormap } from '../TableComponents/constants';

const EmployeeModal = ({ visible, onOk, onCancel, EmployeeData }) => {
  
    function addSpaceBeforeCapital(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2');
    }
    const dataSource = EmployeeData?.data?.rows.map(row => {

        console.log(row, 'asdsadasda')
        const employee = row.Employee;
        const Contractor = row?.ContractorMaster;
        const statusValue = row?.Action || "N/A";
        return {
            key: row.id,
            Status: addSpaceBeforeCapital(statusValue),
            name: employee ? `${employee.firstName} ${employee.lastName}` : Contractor
                ? contractormap(Contractor) : 'N/A',
            assignmentDate: moment.utc(row.AssignmentDate).format('MM-DD-YYYY') || 'N/A',
        };
    }) || [];

    const columns = [
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'name',
        },
        {
            title: 'Assignee Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Assignee Date',
            dataIndex: 'assignmentDate',
            key: 'assignmentDate',
        },
    ];

    return (
        <Modal
            title={<span style={{ fontWeight: 'bold' }}>Hardware History</span>}
            visible={visible}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
            className='tablewidth'


        >
            {dataSource.length > 0 ? (
                <Table dataSource={dataSource} columns={columns} />
            ) : (
                <div>No employee data available.</div>
            )}
        </Modal>
    );
};

export default EmployeeModal;
